import React, { useState } from 'react';
import AdminHeader from './Header';
import '../../styles/Message.css';

function CustomerManagement() {
    const [customer, setCustomer] = useState({
        id: '',
        name: '',
        phone: '',
        address: {
            address1: '',
            address2: '',
            locality: '',
            dist: '',
            state: '',
            pincode: '',
            landmark: ''
        },
        email: '',
        group: '',
        createdAt: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('address.')) {
            const addressField = name.split('.')[1];
            setCustomer(prevState => ({
                ...prevState,
                address: { ...prevState.address, [addressField]: value }
            }));
        } else {
            setCustomer(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("Customer Data Submitted", customer);
    };

    return (
        <AdminHeader>
        <div className="fixed-top-bar">
<form onSubmit={handleSubmit}>
            <h1>Customer Management</h1>
  <div className="form-group">
  <div className="row my-2">
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="id" className="small">Id: </label>
            <input type="number" className="form-control" value={customer.id} onChange={handleChange} placeholder="Customer ID" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Customer name" className="small">Customer Name: </label>
            <input name="name" value={customer.name} onChange={handleChange} placeholder="Customer Name" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="phone number" className="small">Phone Number: </label>
            <input type="number" name="phone" value={customer.phone} onChange={handleChange} placeholder="Phone Number" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Address1" className="small">Address1: </label>
            <input name="address.address1" value={customer.address.address1} onChange={handleChange} placeholder="Address Line 1" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Address2" className="small">Address2: </label>
            <input name="address.address2" value={customer.address.address2} onChange={handleChange} placeholder="Address Line 2" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Locality" className="small">Locality: </label>
            <input name="address.locality" value={customer.address.locality} onChange={handleChange} placeholder="Locality" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="District" className="small">District: </label>
            <input name="address.dist" value={customer.address.dist} onChange={handleChange} placeholder="District" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="State" className="small">State: </label>
            <input name="address.state" value={customer.address.state} onChange={handleChange} placeholder="State" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Pincode" className="small">Pincode: </label>
            <input type="number" name="address.pincode" value={customer.address.pincode} onChange={handleChange} placeholder="Pincode" maxLength={6}/><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Landmark" className="small">Landmark: </label>
            <input name="address.landmark" value={customer.address.landmark} onChange={handleChange} placeholder="Landmark" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Email" className="small">Email: </label>
            <input type="email" name="email" value={customer.email} onChange={handleChange} placeholder="Email ID" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="Group" className="small">Group: </label>
            <input name="group" value={customer.group} onChange={handleChange} placeholder="Group" /><br/>
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <button type="submit">Submit</button>
            </div>
            </div>
            </div>
        </form>
        </div>
        </AdminHeader>
    );
}

export default CustomerManagement;